import { SvgIconProps } from "../types";

export const SvgIcon = ({ src, width, height}: SvgIconProps) => {
    if(src.includes('svg')) {
        return <img src={`/img/svg/${src}`} alt={src} width={width} height={height}/>
    } else {
        return <img src={`/img/landing/${src}`} alt={src} width={width} height={height}/>
    }
};
